import React from 'react';
import { FavouriteCard } from '../../components/FavouriteCard';
import { cloth } from '../../assets/images';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';

const BuyerFavouritePage: React.FC = () => {

  const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
      return text; // nothing to truncate
    } else {
      return text.slice(0, maxLength) + "...";
    }
  }

  const product = [
    {
      id: "1",
      image: cloth,
      name: truncateText("Woolen Plaid Dress X Trenching", 27),
      price: 120,
      rate: 4.5,
      review: 210,
      detail: truncateText(
        "The Highland Mid Calf Boots with a minimalist lace-up design, subtle stitching.",
        78
      ),
    },
    {
      id: "2",
      image: cloth,
      name: truncateText("AirMax Runner Sneakers 2025 Edition", 27),
      price: 95,
      rate: 4.2,
      review: 156,
      detail: truncateText(
        "Lightweight running sneakers designed for comfort and speed, featuring breathable mesh.",
        78
      ),
    },
    {
      id: "3",
      image: cloth,
      name: truncateText("Vintage Leather Shoulder Bag", 27),
      price: 250,
      rate: 4.8,
      review: 320,
      detail: truncateText(
        "Handcrafted leather bag with premium finish, perfect for both casual and formal outings.",
        78
      ),
    },
    {
      id: "4",
      image: cloth,
      name: truncateText("Classic Baseball Cap", 27),
      price: 35,
      rate: 4.0,
      review: 85,
      detail: truncateText(
        "Durable cotton cap with adjustable strap and embroidered logo on the front.",
        78
      ),
    },
    {
      id: "5",
      image: cloth,
      name: truncateText("Urban Bomber Jacket", 27),
      price: 180,
      rate: 4.6,
      review: 275,
      detail: truncateText(
        "Stylish bomber jacket crafted from premium nylon with ribbed cuffs and a warm lining.",
        78
      ),
    },

  ];

  return (
    <div className={styles.container}>

      <div className={styles.subContainer}>

        <div className={styles.fav}>

          <Typography className={styles.favText}>
            My Favourite
          </Typography>

        </div>

        <div className={styles.productsContainer}>
          {product.map((item) => (
            <FavouriteCard
              id={item.id}
              image={item.image}
              name={item.name}
              price={item.price}
              rate={item.rate}
              review={item.review}
              detail={item.detail ?? ""}
            />
          ))}
        </div>

      </div>

    </div>
  );
};

export default BuyerFavouritePage;
